import type { Board } from "../board";
import { BasicAI } from "../ai/basicAI";
import { deserializeXY } from "../serialization";
import { Mob } from "../mob";
import { ParticleType } from "../particleType";
import type { PhysicalThing } from "../physicalThing";
import type { XY } from "../xy";
import { SquidCorpse } from "./squidCorpse";

export class SnakeHead extends Mob {
	static key = "SnakeHead";
	private ai: BasicAI;

	constructor(xy: XY) {
		super(xy);
		this.ai = new BasicAI(this);
	}

	override getBloodParticleType(): ParticleType {
		return ParticleType.BLOOD;
	}

	generateCorpse(): PhysicalThing | null {
		return new SquidCorpse(this.xy);
	}

	processMobAction(_board: Board): void {
		this.ai.processTurn();
	}

	static deserialize(data: any): SnakeHead {
		const m = new SnakeHead(deserializeXY(data.xy));
		m.restoreMobFields(data);
		return m;
	}
}
